import { makeAutoObservable, runInAction } from "mobx";

import Constants from "../../constants/Common";

export class PerPageSettings {
  firstItemNumber = 0;
  constructor(page = 1, perPage = Constants.perPageInitialValue) {
    makeAutoObservable(this);

    this.page = page;
    this.perPage = perPage;
  }

  page = 0;
  total = 0;
  pages = 0;

  perPage = Constants.perPageInitialValue;

  updateMeta = (data) => {
    runInAction(() => {
      this.total = data.itemsTotal;
      this.pages = data.pagesTotal;
      this.firstItemNumber = data.firstItemNumber;
      this.checkCountItems();
    });
  };

  onPageChange = (page) => {
    runInAction(() => {
      this.page = page.selected + 1;
    });
  };

  setPage = (value) => {
    runInAction(() => {
      this.page = value;
    });
  };

  onPerPageChange = (value) => {
    runInAction(() => {
      this.perPage = value;
      this.page = 1;
    });
  };

  checkCountItems = () => {
    //проверка для переброса на первую страницу
    if (this.total < (this.page - 1) * this.perPage) {
      this.page = 1;
    }
  };
}
